var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card__scroller"},[_c('AppSimplebar',_vm._b({attrs:{"data-simplebar-auto-hide":"false"}},'AppSimplebar',{ offsetMarginX: _vm.offsetMarginX, offsetMarginY: _vm.offsetMarginY },false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }